export const NOTIFICATION_TABS = ['all', 'alert', 'purchase', 'system'] as const;

export type NotificationTab = (typeof NOTIFICATION_TABS)[number];

export type NotificationParent = 'alert' | 'purchase' | 'system';

export type NotificationSubtype =
  | 'missedCall'
  | 'makeFriend'
  | 'purchaseCoin'
  | 'supplyCoin'
  | 'supplyLuckybox'
  | 'compensateCoin'
  | 'purchaseTimeBuff'
  | 'client';

/** 서버 문서를 화면이 쓰는 모양으로 편 것. 시각은 전부 ms 로 맞춘다. */
export type Notification = {
  id: string;
  parentCategory: NotificationParent;
  subtype: NotificationSubtype;
  category: string;
  createdTime: number;
  /** 화면에 들어온 시점의 기준선으로 한 번만 정한다. 스크롤 중에 바뀌면 안 된다. */
  unread: boolean;
  senderUid?: string;
  /** 상대를 못 찾은 알림은 목록에서 빠지므로 alert 카드에는 늘 들어 있다. */
  sender?: UserInfo;
  status?: string;
  amount?: number;
  count?: number;
  billingCompletedAt?: number;
  reportNick?: string;
};

export type NotificationPage = {
  items: Notification[];
  token: unknown;
  /** 서버가 다음 토큰을 안 준 경우만 true. 조회 실패는 여기 들어오지 않는다. */
  done: boolean;
};
